<div class="alert alert-success" *ngIf="alertSuccess">
  Admin added successfully!
</div>
<div class="alert alert-danger" *ngIf="alertFailure">
   {{errorMsg}} !
</div>
<div class="alert alert-success" *ngIf="deleteSuccess">
  Admin deleted successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>

<div class="common-padding">
    
  <h4 class="headspace">CHAPTER ADMIN</h4>
   <form class="admin-font-style">  
    <div class="col-md-6 inlineFlex leftFloat zeroLeftPad">
    <label class="col-md-3 zeroLeftPad">Select Site</label>
      <ng-select placeholder ="--Select Site--" class="col-md-8" [items]="siteList" name="siteName" bindLabel="siteName" [(ngModel)]="selectedSite" (change)="siteChange($event)" ></ng-select>   
   </div>
   <div class="col-md-6 inlineFlex zeroRightPad">
     <span class="divide-width"></span>
   <label class="col-md-3">Select BPG <span class="star"> *</span></label>
     <ng-select placeholder ="--Select BPG--"  class="col-md-8 zeroRightPad" [items]="bpgList" name="bpgName" bindLabel ="bpgName" [(ngModel)]="selectedBpg" (change)="bpgChange($event)"></ng-select>    
  </div>
  <div class="col-md-6 inlineFlex leftFloat zeroLeftPad">
      <label class="col-md-3 zeroLeftPad">Select User <span class="star"> *</span></label>
        <ng-select placeholder ="--Select User--"  class="col-md-8" [items] = "userList" name="userFirstName" bindLabel ="userFirstName" bindValue="userId" [(ngModel)]="userFirstName" (change)="userSelection($event)" >
          <ng-template ng-option-tmp let-item="item" let-index="index">
            <div>{{item.userFirstName}}</div>
            <div *ngIf="item.division" style="font-size: 11px">{{item.division}}</div>
            <div *ngIf="item.classification" style="font-size: 11px">{{item.classification}}</div>
          </ng-template>
       </ng-select> 
   
     </div>
     <div class="col-md-6 inlineFlex zeroRightPad">
      <span class="divide-width"></span>
     <label class="col-md-3">Select User Role <span class="star"> *</span></label>  
       <ng-select placeholder ="--Select User Role--"  [(ngModel)] ="roleName" class="col-md-8 zeroRightPad" [items] = "roleList" name="roleName" bindLabel ="roleName" bindValue="roleId" (change)="roleSelection($event)" ></ng-select> 
  </div>
  <p class="text-center errorMessage" *ngIf="bpgNotSelected">Please select Bpg</p>
  <p class="text-center errorMessage" *ngIf="userNotSelected">Please select user</p>
  <p class="text-center errorMessage" *ngIf="roleNotSelected">Please select user role</p>
  <p class="top-space text-center" >
  <button type="submit" id="submitButton" class="btn btn-danger col-sm-2 col-md-2 style"  (click)="submit()" >ADD</button>
  <span class="preview"></span>  
    <button type=" button" class="btn btn-danger col-sm-2 col-md-2 style" (click)="reset()" data-toggle="modal" data-target="#myModal">RESET</button>
    <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
  </p>
</form>
  <div class="searchBy inlineFlex"> 
    <label class="col-md-1 zeroLeftPad">Search</label>
    <input type="text" class="form-control margin-width" maxlength="50" placeholder="Search by name, site and bpg"
        [(ngModel)]="searchKey" (keyup.enter)="searchMe()">
  </div> 

  <p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
<div id="tabledemo1"  *ngIf="tableShow">
<div class="table-container">
  <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
    <thead>
      <tr class="tr-th">
        <th scope="col" (click)="sortMe('user_first_name')" class = "name">Name <span class="sortupdown"><i id="user_first_name1"
          class="fa fa-sort-up"></i><i id="user_first_name2" class="fa fa-sort-down"></i></span></th>
        <th scope="col">Site</th>
        <th scope="col">BPG</th>
        <th scope="col">User Role</th>
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of adminData  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }">
        <td>{{data.userFirstName}}&nbsp;{{data.userLastName}}</td>
        <td>{{data.siteName}}</td>
        <td>{{data.bpgName}}</td>
        <td>{{data.adminName}}</td>
        <td>
          <a *ngIf="loginUserId != data.userId" (click)="delete(data)" class="edit-delete" data-toggle="modal" data-target="#myModal"><img src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
        </td>
      </tr>

    </tbody>
  </table>
</div>

<div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
  <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
  <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
</div>
</div>
</div>
